import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { CONTACT_QUERY_KEY } from './useContact';

export function useContactKeyDateDeleteMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: Api.IContact) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ contactId, keyFactId }: { contactId: string; keyFactId: string }) => {
			return userSession.webServiceHelper.callAsync<Api.IContact>(
				`contact/${encodeURIComponent(contactId)}/keyfacts/${encodeURIComponent(keyFactId)}/keyDate`,
				'DELETE',
				null
			);
		},
		onSuccess: result => {
			// Invalidate and update contact queries - match the default useContact query key structure
			queryClient.invalidateQueries({
				queryKey: [CONTACT_QUERY_KEY, { allowArchived: false, contactId: result.id, expandHouseholdMembers: false }],
			});
			onSuccess?.(result);
		},
		onError,
	});
}
